import { render, staticRenderFns } from "./formNews.vue?vue&type=template&id=0d279bac"
import script from "./formNews.vue?vue&type=script&lang=js"
export * from "./formNews.vue?vue&type=script&lang=js"
import style0 from "./formNews.vue?vue&type=style&index=0&id=0d279bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports